export function getYoutubeIframeApi() {
    if (window.YT?.Player) {
        return Promise.resolve(window.YT);
    }

    if (window.__youtubeIframeApiPromise) {
        return window.__youtubeIframeApiPromise;
    }

    window.__youtubeIframeApiPromise = new Promise(resolve => {
        const existingScript = document.querySelector('script[data-youtube-iframe-api="true"]');
        const previousHandler = window.onYouTubeIframeAPIReady;

        window.onYouTubeIframeAPIReady = () => {
            if (typeof previousHandler === 'function') {
                previousHandler();
            }

            resolve(window.YT);
        };

        if (!existingScript) {
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            script.async = true;
            script.dataset.youtubeIframeApi = 'true';
            document.head.appendChild(script);
        }
    });

    return window.__youtubeIframeApiPromise;
}